import React from 'react';
import { Card, Col, Layout, Row } from 'antd';
import LoginButton from '../../../app/components/LoginButton';



const PageLogin = () => {
  return (
    <Layout className="login">
      <Row>
        <Card
          style={{
            textAlign: 'center',
            boxShadow: 'rgb(24 26 27 / 69%) 0px 0px 8px 2px',
            background: '#343a40e3',
          }}
        >
          <h1 className='login-font'>Логин</h1>
          <p className='login-font'>Добро пожаловать, пожалуйста войдите в свой аккаунт.</p>
          <Col>
            <LoginButton />
          </Col>
        </Card>
      </Row>
    </Layout>
  );
};


export default PageLogin;
